export default {
  POST: { value: 0, label: '帖子' },
  MEMBER: { value: 1, label: '员工' },
  CIRCLE: { value: 2, label: '圈子' },
  BANNED: { value: 3, label: '禁言' },
  UNBANNED: { value: 4, label: '解除禁言' },
}
